import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type JobDetailCardProps = {
  title: string
  children: ReactNode
  className?: string
}

export const JobDetailCard = ({ title, children, className }: JobDetailCardProps) => (
  <div className={cn('flex flex-col gap-3', className)}>
    <h3 className="text-base font-semibold text-foreground">{title}</h3>
    <section className="rounded-xl bg-muted-foreground/10 p-6">
      {children}
    </section>
  </div>
)
